import { setToken, removeToken, encryptor } from '@/utils/auth'
import { setStore, getStore ,removeStore} from '@/utils/store'

import { isURL, validatenull } from '@/utils/validate'
import { deepClone, local } from '@/utils/util'
import website from '@/config/website'
import { hasRoleCheck, hasRole } from '@/utils/authVerify'


import {
  loginByUsername,
  validateToken,
  getUserInfo,
  getMenu,
  getTopMenu,
  getButtons,
  routes,
  loginEFiling,
} from '@/api/user'
import {computed} from "vue";

// Define the type for the state object
interface UserState {
  userInfo: any
  permission: { [key: string]: boolean },
  btnSeqList: { [key: string]: any },
  dimensions: any
  posts: any[]
  roles: any[]
  menu: any[]
  menuAll: any[]
  token: string
  systemId: string
  taskListDialog: any
  taskType: string
  addBuyer: boolean
  addContact: boolean
  setAddress: boolean
  nextStep: number
  [key: string]: any // Add an index signature
}

function addPath(ele: any, first: boolean) {
  const menu = website.menu
  const propsConfig = menu.props
  const propsDefault = {
    label: propsConfig.label || 'name',
    path: propsConfig.path || 'path',
    icon: propsConfig.icon || 'icon',
    children: propsConfig.children || 'children',
  }
  const icon = ele[propsDefault.icon]
  ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon
  const isChild =
    ele[propsDefault.children] && ele[propsDefault.children].length !== 0
  if (!isChild) ele[propsDefault.children] = []
  if (!isChild && first && !isURL(ele[propsDefault.path])) {
    ele[propsDefault.path] = ele[propsDefault.path] + '/index'
  } else {
    ele[propsDefault.children].forEach((child: any) => {
      addPath(child, false)
    })
  }
}

function replaceMenuPlaceholders(menu: any[],aliasConfigs:any[],parentId:any) {
  console.log("replaceMenuPlaceholders",menu,aliasConfigs,parentId);
  if(!['zh-CN','en-US'].includes(parentId)){
    return menu;
  }
  if(!aliasConfigs || aliasConfigs.length==0){
    return menu;
  }
  const lanAliasConfig = aliasConfigs.map(item=>{
    return {
      placeholder: item.placeholder,
      replaceText: item[parentId]
    }
  })
  // 创建占位符映射表，提高查找效率
  const placeholderMap = new Map<string, string>();
  lanAliasConfig.forEach(config => {
    placeholderMap.set(config.placeholder, config.replaceText);
  });

  // 递归替换函数
  function replaceInMenu(items: any[]) {
    items.forEach(item => {
      // 检查并替换 name 属性中的占位符
      if (item.name && typeof item.name === 'string') {
        let newName = item.name;
        placeholderMap.forEach((replaceText, placeholder) => {
          newName = newName.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), replaceText);
        });
        item.name = newName;
      }

      // 递归处理子菜单
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        replaceInMenu(item.children);
      }
    });
  }

  // 对整个菜单进行替换处理
  replaceInMenu(menu);
  return menu;
}


const user = {
  state(): UserState {
    return {
      userInfo: {},
      permission: {},
      btnSeqList: {},
      dimensions: {},
      roleInfo: {
        isSGS: false,
        isSupplier: false,
        isBuyer: false,
        isAgent: false,
        isThirdPartyLab: false,
      },
      posts: [],
      roles: [],
      menu: [],
      menuAll: [],
      token: '',
      systemId: '',
      taskListDialog: null,
      taskType: '',
      addBuyer: false,
      addContact: false,
      setAddress: false,
      nextStep: -1,
      isSGS: false,
    }
  },
  actions: {
    async LoginByUsername({ commit }: { commit: any }, userInfo: any) {
      try {
        let pass = encryptor(userInfo.password)
        let permission: string[] = []
        const res = await loginByUsername(
          userInfo.tenantId,
          userInfo.username,
          pass,
          userInfo.type,
          userInfo.receiveMarketingCommunication,
        )
        console.log("LoginByUsername",res);
        debugger
        const data = res.data
        commit('SET_TASK_DIALOG', data.guide)
        commit('SET_TOKEN', data.accessToken)
        local.set('SGS-userInfo', {
          content: data,
          dataType: "object",
          datetime:Date.now()
        })

        commit('SET_USERIFNO', data)

        let permissionSeqMap = data.permissionSeqMap || {}
        commit('SET_BTNSEQ',permissionSeqMap);

        permission.push(...data.permissions.split(','))
        commit('SET_DIMENSIONS', data.dimensions)
        commit('SET_POSTS', data.posts)
        let { tcpp, userMgtId } = data
        commit('SET_PERMISSION', permission)

        const routesRes = await routes()
        let routesData = routesRes.data
        permission.push(...routesData.buttons.map((item: any) => item.code))
        commit('SET_PERMISSION', permission)


        await loginEFiling(data.accessToken)
        return { tcpp, userMgtId }
      } catch (error) {
        throw error
      }
    },
    async LoginByToken({ commit,state }:any, token: string) {
      try {
        const res = await validateToken(token)
        const data = res.data
        if (data.accessToken) {
          // setStore({ name: 'userInfo', content: data })
          // const userInfo = getStore({ name: 'userInfo' })
          const userInfo = data
          commit('SET_TOKEN', data.accessToken)
          console.log("11111111111 这要第一个加载，不然获取不到用户信息")
          commit('SET_USERIFNO', userInfo)
          // commit('SET_USERIFNO', state.userInfo)
          commit('SET_PERMISSION', data.permissions.split(','))
          commit('SET_DIMENSIONS', data.dimensions)
          commit('SET_POSTS', data.posts)
          commit('SET_IS_SGS', userInfo)
          const roleInfo = {
            isSGS:
              hasRole('SGSUserRole', 'SgsAdmin', userInfo) ||
              hasRole('SGSUserRole', 'SgsLabUser', userInfo),
            isSupplier: hasRole('UserRole', 'Supplier', userInfo),
            isBuyer: hasRole('UserRole', 'Buyer', userInfo),
            isAgent: hasRole('UserRole', 'Agent', userInfo),
            isThirdPartyLab: hasRole('UserRole', 'ThirdPartyLab', userInfo),
          }
          commit('SET_ROLE_INFO', roleInfo)

        }
      } catch (error) {
        throw error
      }
    },
    async GetButtons({ commit }: { commit: any }) {
      try {
        const res = await getButtons()
        const data = res.data
        commit('SET_PERMISSION', data)
      } catch (error) {
        throw error
      }
    },
    async LoginByPhone({ commit }: { commit: any }, userInfo: any) {
      try {
        const res = await loginByUsername(userInfo.phone, userInfo.code)
        const data = res.data
        commit('SET_TOKEN', data)
      } catch (error) {
        throw error
      }
    },
    async GetUserInfo({ commit }: { commit: any }) {
      try {
        const res = await getUserInfo()
        const data = res.data
        commit('SET_ROLES', data.roles)
        return data
      } catch (error) {
        throw error
      }
    },

    async LogOut({ commit }: { commit: any }) {
      try {
        commit('SET_TOKEN', '')
        commit('SET_MENU', [])
        commit('SET_ROLES', [])
        commit('SET_USERIFNO', {})
        let token = getStore({ name: 'token'});
        removeStore({ name:token,type:'session'})
        removeToken()
      } catch (error) {
        throw error
      }
    },
    async FedLogOut({ commit }: { commit: any }) {
      commit('SET_TOKEN', '')
      commit('SET_MENU', [])
      commit('SET_ROLES', [])
      removeToken()
    },
    async GetTopMenu() {
      try {
        const res = await getTopMenu()
        const data = res.data || []
        return data
      } catch (error) {
        throw error
      }
    },
    async GetMenu({ commit,rootState }: { commit: any; rootState:any, dispatch: any }, parentId: any) {
      try {
        const aliasConfigs = rootState.i18n?.aliasConfigs || [];
        console.log("999. Get Menu getAliasConfigs1",aliasConfigs)
        //console.log("Get Menu",commit,parentId)
        const res = await getMenu(parentId)
        //console.log("Get Menu res",res)
        const data = res.data
        let menu = deepClone(data)

        menu = replaceMenuPlaceholders(menu, aliasConfigs,parentId);

        menu && menu.forEach((ele: any) => {
            addPath(ele, true)
          })
        commit('SET_MENU', menu)
        return menu
      } catch (error) {
        throw error
      }
    },
  },
  mutations: {
    SET_TASK_DIALOG(state: UserState, bool: any) {
      state.taskListDialog = bool
    },
    SET_TASK_TYPE(state: UserState, type: string) {
      state.taskType = type
    },
    SET_GUIDE(state: UserState, obj: { name: string; val: any }) {
      state[obj.name] = obj.val
    },
    SET_NEXTSTEP(state: UserState, num: number) {
      state.nextStep = num
    },
    SET_TOKEN(state: UserState, token: string) {
      setToken(token)
      state.token = token
      setStore({ name: 'token', content: token, type: 'session' })
      setStore({ name: 'token', content: token })
    },
    SET_USERIFNO(state: UserState, userInfo: any) {
      let tokenUserInfo = getStore({ name: userInfo.accessToken });
      let pageUserInfo = tokenUserInfo || userInfo;
      state.userInfo = pageUserInfo;
      setStore({ name: 'userInfo', content: pageUserInfo, type: 'session' })
      setStore({ name: 'userInfo', content: pageUserInfo })
    },
    SET_MENU(state: UserState, menu: any[]) {
      state.menu = menu
      setStore({ name: 'menu', content: state.menu, type: 'session' })
      setStore({ name: 'menu', content: state.menu })
    },
    SET_MENU_ALL(state: UserState, menuAll: any[]) {
      state.menuAll = menuAll
    },
    SET_ROLES(state: UserState, roles: any[]) {
      state.roles = roles
    },
    SET_PERMISSION(state: UserState, permission: string[]) {
      state.permission = {}
      permission &&
        permission.forEach((ele) => {
          state.permission[ele] = true
        })
      setStore({
        name: 'permission',
        content: state.permission,
        type: 'session',
      })
      setStore({
        name: 'permission',
        content: state.permission
      })
    },
    SET_BTNSEQ(state: UserState, btnSeq: any) {
      console.log("登录之后设置了btnseq");
      // alert(1)
      state.btnSeqList = btnSeq
      setStore({
        name: 'btnSeqList',
        content: btnSeq,
        type: 'session',
      })
      setStore({
        name: 'btnSeqList',
        content: btnSeq
      })
    },
    SET_DIMENSIONS(state: UserState, dimensions: any) {
      state.dimensions = dimensions
      setStore({
        name: 'dimensions',
        content: state.dimensions,
        type: 'session',
      })
      setStore({
        name: 'dimensions',
        content: state.dimensions
      })
    },
    SET_POSTS(state: UserState, posts: any[]) {
      state.posts = posts
      setStore({ name: 'posts', content: state.posts })
      setStore({ name: 'posts', content: state.posts, type: 'session' })
    },
    SET_SYSTEM_ID(state: UserState, systemId: string) {
      state.systemId = systemId
      setStore({ name: 'systemId', content: state.systemId })
      setStore({ name: 'systemId', content: state.systemId, type: 'session' })
    },
    SET_IS_SGS(state: UserState, userInfo: any) {
      const isSGS =
        hasRoleCheck('SGSUserRole', 'SgsAdmin', userInfo) ||
        hasRoleCheck('SGSUserRole', 'SgsLabUser', userInfo)
      state.isSGS = isSGS
    },
    SET_ROLE_INFO(state: UserState, roleInfo: any) {
      state.roleInfo = roleInfo
    }

  },
}

export default user
